import { CardContainer, RevisionHistorySection } from '@/_containers';
import { ViewLogSection } from '@/_containers/view-logs';

import { usePageContext } from '../../shared';

export function ProfileRightSection() {
  const { id, isReverting, revisionHistory } = usePageContext();

  return (
    <>
      <CardContainer right bodyClassName="3xl:pr-0 pr-0">
        <RevisionHistorySection id={`${id}`} endpoint="inventories" disabled={isReverting} {...revisionHistory} />
      </CardContainer>

      <CardContainer right bodyClassName="3xl:pr-0 pr-0">
        <ViewLogSection id={`${id}`} endpoint="inventories" />
      </CardContainer>
    </>
  );
}
